<template>
  <div class="page">
    <div class="container">
      <div class="flex align-center mb-30">
        <img src="/images/weizhi.png" alt="" class="mr-10">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index.html' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/case.html' }">看案例</el-breadcrumb-item>
          <el-breadcrumb-item>{{caseItem.name}}- 案例详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="section mb-90">
        <div class="flex h-400 mb-30">
          <div class="pic mr-30">
            <el-image :src="Utils.IMG_PREV + caseItem.casePicList[currentImgIndex].pic" fit="cover" class="w-100 h-100"></el-image>
          </div>
          <div class="flex-1 w-0">
            <div class="flex align-center justify-space-between mb-24">
              <div class="flex-1">
                <img src="/images/yinhao.png" alt="" class="mb-20">
                <div class="font-30 font-yahei color-292a2e mb-14">{{caseItem.name}}</div>
                <div class="flex align-center">
                  <div>
                    <div class="font-12 color-94 mb-4">设计风格</div>
                    <div class="font-16 font-yahei color-292a2e">{{caseItem.style}}</div>
                  </div>
                  <div class="line"></div>
                  <div>
                    <div class="font-12 color-94 mb-4">房屋户型</div>
                    <div class="font-16 font-yahei color-292a2e">{{caseItem.layout}}</div>
                  </div>
                  <div class="line"></div>
                  <div>
                    <div class="font-12 color-94 mb-4">装修面积</div>
                    <div class="font-16 font-yahei color-292a2e">{{caseItem.area}}㎡</div>
                  </div>
                </div>
              </div>
              <div class="line-dashed"></div>
              <div class="right">
                <div class="headImg mb-18"><el-image :src="Utils.IMG_PREV+caseItem.designerHead" fit="cover" class="w-100 h-100"></el-image></div>
                <div class="font-12 color-94 mb-6 text-center">设计师</div>
                <div class="font-16 color-292a2e font-yahei text-center">{{caseItem.designer == '全部设计师' ? '-':caseItem.designer}}</div>
              </div>
            </div>
            <div class="color-c19357 font-30 font-arial mb-24">¥{{Utils.toFixedNum(caseItem.price)}}</div>
            <div class="mb-34">
              <img src="/images/baohankongjian.png" alt="" class="block">
              <div class="room flex align-center" style="padding-left:40px">
                <div class="flex align-center" v-for="(cellItem, cellIndex) in caseItem.caseSpaceList" :key="cellIndex">
                  <div class="flex-column align-center justify-center">
                    <div class="text-center">
                    <img
                    style="width: 25px;"
                    class="mr-10"
                    :src="cellItem.icon ? Utils.IMG_PREV+cellItem.icon : ''"
                    />
                    </div>
                    <!-- <img :src="Utils.IMG_PREV+cellItem.icon" class="mr-10" style="width:20px"> -->
                    <div class="font-14 font-yahei color-292a2e">{{cellItem.name}} </div>
                  </div>
                  <div class="line"></div>
                </div>
              </div>
            </div>
            <div class="flex align-center">
              <div class="vr-item mr-10 cursor align-center flex" v-for="(cellItem, cellIndex) in caseItem.casePanoramaList" :key="cellIndex">
                <div class="pic flex-column align-center justify-center" :style="{background:'url(' + Utils.IMG_PREV + caseItem.casePicList[currentImgIndex].pic + ') no-repeat center/cover'}">
                  <div>
                    <img src="/images/vr.png" alt="">
                  </div>
                </div>
                <div class="flex-1 text-center">VR全景{{cellIndex+1}}</div>
                <img src="/images/jinruxiangqingbaibeijing.png" alt="" class="ml-10">
              </div>
            </div>
          </div>
        </div>
        <div class="hr-dashed mb-30"></div>
        <div class="flex align-center">
          <div class="bg-f9f4ee radius-4 color-c19357 font-16 introduce-icon flex-column align-center justify-center">
            <div>设计</div><div>说明</div>
          </div>
          <div class="font-12 color-94 flex-1 w-0 lh-18">{{caseItem.profile}}</div>
        </div>
      </div>
      <div class="flex align-start p-relative roomList" ref="roomList">
        <div class="w-778 mr-30">
          <div class="room-section mb-90" v-for="(cellItem, cellIndex) in caseItem.caseSpaceList" ref="caseRoom" :key="cellIndex">
            <div class="flex align-center mb-26">
              <img :src="Utils.IMG_PREV+cellItem.icon" class="mr-10" style="width:47px;height:40px">
              <div class="font-32 color-292a2e font-yahei">{{cellItem.name}}</div>
              <!-- <div class="line"></div>
              <div class="flex align-center">
                <div v-for="(item, index) in 2" :key="index" class="flex align-center">
                  <i class="el-icon-plus font-10 color-94 font-bold mlr-10" v-if="index !== 0"></i>
                  <span class="tag-16-c19357-1-round">茶几</span>
                </div>
              </div> -->
            </div>
            <div class="room-pic mb-10" v-for="(picItem,picIndex) in cellItem.caseSpacePicList" :key="picIndex">
              <img :src="Utils.IMG_PREV+picItem.pic" class="w-100">
            </div>
          </div>
        </div>
        <div class="float-section" :class="isFixed ? 'fixed' : fixPosition == 'bottom' ? 'sec-bottom' : 'sec-top'">
          <div class="flex align-center mb-26">
            <img src="/images/fangan-shiyongshangpin.png" alt="" class="mr-10">
            <div class="font-32 color-292a2e font-yahei">案例使用商品</div>
          </div>
          <div class="good-list">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane v-for="(item, index) in caseItem.caseSpaceList" :key="index" :label="item.name" :name="index.toString()">
                <div class="p-30 good-main">
                  <goods-case v-for="(goodItem, goodIndex) in item.caseSpaceGoodsList" :key="goodIndex" :goodItem="goodItem" :spaceIndex="index" :goodIndex="goodIndex" @on-choose="onChoose"></goods-case>
                </div>
              </el-tab-pane>
            </el-tabs>
            <div class="p-30 flex justify-end align-center bottom">
              <div class="flex-1">
                <div class="font-16 color-292a2e">已选<span class="font-22 font-bold font-arial"> {{totalNum}} </span>件商品</div>
                <div class="font-12 color-292a2e">提示：您可以将已选商品保存到我的方案哦！</div>
              </div>
              <div class="btn-40 bg-292a2e color-ff w-172 radius-round font-yahei" @click="toSave">保存到我的方案</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal " v-if="isSaveSuccess" @scroll.stop.prevent @touchmove.prevent>
      <div class="content-save">
        <div class="flex justify-end p-10 mb-28">
          <img src="/images/guanbi.png" alt="" @click="onCloseSave" class="cursor">
        </div>
        <div class="flex-1 flex-column align-center justify-center">
          <img src="/images/chenggong.png" alt="" class="mb-16">
          <div class="font-22 color-292a2e font-yahei mb-4">保存成功</div>
          <div class="font-14 color-94 font-yahei">此方案已保存到我的方案中</div>
          <div class="font-14 color-94 font-yahei">请保持手机畅通，我们会及时联系您</div>
          <div class="font-14 color-94 font-yahei mb-60">并为您的方案提供更完善可行的调整设计！</div>
          <div class="btn-40 bg-292a2e font-16 color-ff radius-round plr-30 font-yahei" @click="lookMyCase">查看我的方案</div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import GoodsCase from '@/components/GoodsCase'
export default {
  name: 'CaseDetail',
  components: {GoodsCase},
  computed: {},
  data () {
    return {
      value: 4,
      roomIndex: 0,
      roomName: '',
      isSaveSuccess: false,
      activeName: '0',
      id: '',
      caseItem: {},
      currentImgIndex: 0,
      totalNum: 0,
      myCase: {},
      isFixed: false,
      fixPosition: '',
      sectionInx: 0
    }
  },
  mounted () {
    this.id = this.$route.query.id.slice(0,-5)
    if (this.id) {
      this.getById()
    }
    window.addEventListener("scroll",this.onScroll3)
    this.windowHeight = document.documentElement.clientHeight
  },
  beforeDestroy(){
    window.removeEventListener("scroll",this.onScroll3)
  },
  methods: {
    getById () {
      this.axios.post(`cases/getById`, this.qs.stringify({id: this.id})).then(res => {
        if (res.data.success) {
          this.caseItem = res.data.data
          this.currentImgIndex = parseInt(Math.random()*(this.caseItem.casePicList.length-1)+0)
        }
      })
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    onChoose (e) {
      if (this.$store.state.token && this.$store.state.user) {
        this.caseItem.caseSpaceList[e.spaceIndex].caseSpaceGoodsList[e.goodIndex].selected = e.isSelect
        this.handleGoods()
      } else {
        this.$message({
          message: '此操作需要先登录',
          type: "warn",
          offset: 400
        });
      }
    },
    handleGoods () {
      this.totalNum = 0
      let list = this.caseItem.caseSpaceList
      let MyCase = {
        customerId: this.$store.state.user.id,
        name: this.caseItem.name
      }
      let customerSpaceList = []
      for (let i=0;i<list.length;i++) {
        let item = {
          id: list[i].id,
          caseId:  list[i].caseId,
          name:  list[i].name,
          icon:  list[i].icon,
          customerSpaceGoodsList: []
        }
        customerSpaceList.push(item)
        for (let j=0;j<list[i].caseSpaceGoodsList.length;j++) {
          if (list[i].caseSpaceGoodsList[j].selected) {
            this.totalNum = this.totalNum + list[i].caseSpaceGoodsList[j].quantity
            list[i].caseSpaceGoodsList[j].customerSpaceAttributeList = list[i].caseSpaceGoodsList[j].caseSpaceAttributeList
            customerSpaceList[i].customerSpaceGoodsList.push(list[i].caseSpaceGoodsList[j])
          }
        }
      }
      MyCase.customerSpaceList = customerSpaceList
      this.myCase = MyCase
    },
    submitAddRoom () {
      this.onCloseAdd()
    },
    toSave () {
    if (this.$store.state.token && this.$store.state.user) {
      this.axios.post(`customerProgramme/save`, this.myCase).then(res => {
        if (res.data.success) {
          this.isSaveSuccess = true
        } else {
          this.$message({
            message: res.data.msg,
            type: "warn",
            offset: 400
          });
        }
      })
    } else {
      this.$message({
            message: '此操作需要先登录',
            type: "warn",
            offset: 400
          });
    }
      // this.isSaveSuccess = true
    },
    lookMyCase () {
       this.$router.push({path: '/myScheme.html'})
    },
    onCloseSave () {
      this.isSaveSuccess = false
    },
    deleteGoods (e) {
    },
    onScroll3 () {
      let arr = []
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      for (let i of this.$refs.caseRoom){
        arr.push(i.offsetTop)
      }
      for (let i = arr.length - 1; i >= 0; i--) {
        if (scrollTop > arr[i] + this.$refs.roomList.offsetTop) {
          console.log(this.caseItem.caseSpaceList[i])
          this.activeName = i.toString()
          break
        }
      }
      if (scrollTop > this.$refs.roomList.offsetHeight) {
        this.isFixed = false
        this.fixPosition = 'bottom'
      } else if (scrollTop > this.$refs.roomList.offsetTop-60) {
        this.isFixed = true
      } else {
        this.isFixed = false
        this.fixPosition = 'top'
      }
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
  .page{
    padding: 30px 0 120px;
    background: #eeeff3;
  }
  .section{
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 30px 70px 0px rgba(44, 51, 59, 0.07);
    padding: 30px;
    .introduce-icon{
      width: 50px;
      height: 50px;
      line-height: 18px;
      margin-right: 20px;
    }
    .line{
      height: 40px;
      width: 1px;
      background: #e9e9e9;
      margin: 0 28px;
    }
    .line-dashed{
      height: 144px;
      width: 1px;
      border-right: 1px dashed #e9e9e9;
      margin: 0 28px;
    }
    .headImg{
      width: 86px;
      height: 86px;
      overflow: hidden;
      border-radius: 50%;
    }
    .room{
      background: #f9f4ee;
      border-radius: 4px;
      height: 75px;
      margin-top: -4px;
    }
    .case-item{
      width: 124px;
      height: 82px;
      border-radius: 4px;
      background: url('https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1602583861525&di=45c2f77b0d0520ff2c9b7620967d9c0b&imgtype=0&src=http%3A%2F%2Ftgi12.jia.com%2F121%2F266%2F21266396.jpg') no-repeat center/cover;
      flex-shrink: 0;
      overflow: hidden;
      cursor: pointer;
      .title{
        background: rgba($color: #000000, $alpha: 0.5);
        &:hover{
          background: rgba($color: #c19357, $alpha: 0.85);
        }
      }
    }
    .pic{
      width: 610px;
      height: 100%;
      border-radius: 4px;
      overflow: hidden;
    }
    .price{
      padding-right: 10px;
      margin-right: 10px;
      border-right: 1px solid #e9e9e9;
      line-height: 13px;
    }
    .recommend{
      background: #f9f4ee;
      border-radius: 4px;
      height: 96px;
      width: 100%;
      margin-top: -4px;
      .line{
        height: 40px;
        width: 1px;
        background: #e9e9e9;
        margin: 0 30px;
      }
    }
    .vr-item{
      width: 165px;
      height: 40px;
      border-radius: 30px;
      background: #eeeff3;
      position: relative;
      padding: 0 15px 0 53px;
      .pic{
        width: 52px;
        height: 52px;
        position: absolute;
        border-radius: 50%;
        left: 0;
        top: -6px;
        > div {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba($color: #000000, $alpha: 0.5);
        }
      }
      &:hover .pic > div{
        width: 100%;
        height: 100%;
        background: rgba($color: #c19357, $alpha: 0.85);
      }
    }
  }
  .room-list{
    position: relative;
    &::after{
      content: '';
      display: block;
      width: 100%;
      height: 19px;
      position: absolute;
      top: 0;
      left: 0;
      border-bottom: 1px solid #e9e9e9;
    }
    .btn-40{
      z-index: 9;
    }
    .border-292a2e{
      background: #eeeff3;
    }
  }
  .room-section{
    .line{
      height: 40px;
      width: 1px;
      background: #cacaca;
      margin: 0 20px;
    }
    .room-pic{
      background: #fff;
      padding: 30px;
      border-radius: 4px;
    }
  }
  .good-list{
    background: #fff;
    border-radius: 4px;
    .bottom{
      height: 60px;
      background: #c19357;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
    .good-main{
      height: 60vh;
      overflow-y: auto;
    }
  }
  .roomList{
    min-height: 81vh;
  }


  .modal{
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    .content{
      width: 394px;
      height: 253px;
      background: #ffffff;
      border-radius: 4px;
    }
    .content-save{
      width: 394px;
      height: 432px;
      background: #ffffff;
      border-radius: 4px;
    }
  }

  .w-40{
    width: 40px;
  }
  .w-147{
    width: 147px;
  }
  .w-153{
    width: 153px;
  }
  .w-172{
    width: 172px;
  }
  .h-400{
    height: 400px;
  }
  .w-778{
    width: 778px;
  }

  .float-section{
    width: 592px;
    position: absolute;
    right: calc((100% - 1400px) / 2);
    transition: all 0s;
  }

  .fixed{
    position: fixed;
    top: 80px;
  }
  .sec-bottom{
    bottom: 0;
  }
  .sec-top{
    top: 0;
  }

  ::v-deep{
    .content .el-input__inner{
      text-align: center;
      border: 0;
      height: 50px;
      line-height: 50px;
    }
    .el-tabs__header{
      margin: 0;
    }
    .el-tabs__nav-scroll{
      padding: 0 30px;
    }
    .el-tabs__item{
      height: 58px;
      line-height: 58px;
      font-size: 16px;
      font-family: '微软雅黑',sans serif;
    }
    .el-tabs__item.is-active, .el-tabs__item:hover{
      color: #c19357;
    }
    .el-tabs__nav-wrap::after{
      height: 1px;
      background: #e9e9e9;
    }
    .el-tabs__active-bar{
      background: #c19357;
    }
  }
</style>
